import { ErrorOutlined } from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import { Typography } from '../../primitives/typography/typography';
import { Button } from '../../primitives/button';
import React from 'react';
import { useNavigate } from 'react-router';
import { CodeBlock } from '../../data-display/code-block/code-block';
import IDULogo from '../../../assets/idu-logo-light.svg?react';

export const ErrorPage = ({
  logo: Logo,
  message,
  details,
  stack,
  actions,
}: {
  logo?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  message: string;
  details: string;
  stack?: string;
  actions?: React.ReactNode;
}) => {
  const navigate = useNavigate();
  return (
    <Stack
      direction="column"
      sx={{
        minHeight: '70vh',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 1,
      }}
    >
      <Box sx={{ maxWidth: 480, width: '100%', p: 4, borderRadius: 3, textAlign: 'center' }}>
        <Stack spacing={2} sx={{ alignItems: 'center' }}>
          {Logo ? <Logo style={{ width: 120 }} /> : <IDULogo style={{ width: 120 }} />}
          <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
            <ErrorOutlined sx={{ fontSize: 48, color: 'error.main' }} />
            <Typography.Heading sx={{ color: 'error.main', fontWeight: 700 }}>
              {message}
            </Typography.Heading>
          </Stack>
          <Typography.Body sx={{ color: 'text.secondary' }}>{details}</Typography.Body>
          <Stack direction="row" sx={{ gap: 2 }}>
            {/* Push to root, hope for the best. If they come back here many 
            times they will figure out they need to logout next. */}
            <Button variant="primary" size="large" onClick={() => navigate('/')}>
              Home
            </Button>
          </Stack>
          {actions}
          {stack && (
            <Box sx={{ mt: 2, width: '100%', minWidth: 0, maxHeight: 240, display: 'flex' }}>
              <CodeBlock code={stack} language="javascript" title="Stack Trace" />
            </Box>
          )}
        </Stack>
      </Box>
    </Stack>
  );
};
